import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=6e391867&"
import script from "./addCustomer.vue?vue&type=script&lang=js&"
export * from "./addCustomer.vue?vue&type=script&lang=js&"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=6e391867&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports